import React from 'react'
import type { ComponentConfig } from '@puckeditor/core'
import { WithLayout, withLayout } from '../Layout'
import { Icon, iconField } from '../../fields/IconField'
import { ColorField } from '../../fields/ColorField'

export type IconBlockProps = WithLayout<{
  icon?: string
  color?: string
  size?: string
}>

const IconInternal: ComponentConfig<IconBlockProps> = {
  label: 'Icon',
  // What the editor's agent reads about this block (AgentComponentNotes).
  ai: {
    description: 'One Lucide or Font Awesome icon.',
    fields: {
      icon:
        'Family-prefixed name: lucide:Star (PascalCase Lucide name) or fa:star (Font Awesome 4).',
      color: 'CSS colour; empty inherits the text colour.',
    },
  },
  fields: {
    icon: { ...iconField, label: 'Icon' },
    color: {
      type: 'custom',
      label: 'Color',
      render: (props: React.ComponentProps<typeof ColorField>) => (
        <ColorField {...props} clearable />
      ),
    },
    size: { type: 'text', label: 'Size', placeholder: 'e.g. 24px, 2rem' },
  },
  defaultProps: {
    icon: 'lucide:Star',
    color: '',
    size: '24px',
  },
  render: ({ icon, color, size }) => (
    <Icon value={icon} color={color || undefined} size={size || 24} />
  ),
}

export const PuckIcon = withLayout(IconInternal)
